import api from '@/api/index'

export const useApi = () => api
